@if (objectForm) {
    <nz-spin [nzSpinning]="loading">
        <form nz-form [formGroup]="objectForm" class="login-form" nzLabelAlign="left">
            <nz-form-item>
                <nz-form-label nzRequired nzFor="personTypeId" [nzSm]="8" [nzXs]="24">Personas tips</nz-form-label>
                <nz-form-control clValidationError="personTypeId" [nzSm]="16" [nzXs]="24">
                    <nz-select nzShowSearch nzPlaceHolder="Personas tips" formControlName="personTypeId">
                        @for (p of personTypes$ | async; track p.id) {
                            <nz-option [nzLabel]="p.name" [nzValue]="p.originalLuidaisId"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzFor="clientTypeId" [nzSm]="8" [nzXs]="24">Klienta tips</nz-form-label>
                <nz-form-control clValidationError="clientTypeId" [nzSm]="16" [nzXs]="24">
                    <nz-select nzShowSearch nzPlaceHolder="Klienta tips" formControlName="clientTypeId">
                        @for (ct of clientTypes$ | async; track ct.id) {
                            <nz-option [nzLabel]="ct.name" [nzValue]="ct.originalLuidaisId"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired nzFor="sex" [nzSm]="8" [nzXs]="24">Dzimums</nz-form-label>
                <nz-form-control clValidationError="sex" [nzSm]="16" [nzXs]="24">
                    <nz-select nzShowSearch nzPlaceHolder="Dzimums" formControlName="sex">
                        @for (s of sexes$ | async; track s.id) {
                            <nz-option [nzLabel]="s.name" [nzValue]="s.name"></nz-option>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired [nzSm]="8" [nzXs]="24" nzFor="name">{{
                    selectedPersonType == personTypes.Physical ? 'Vārds' : 'Veids'
                }}</nz-form-label>
                <nz-form-control clValidationError="name" [nzSm]="16" [nzXs]="24">
                    <input type="text" nz-input id="name" formControlName="name" placeholder="Vārds" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired nzFor="surname" [nzSm]="8" [nzXs]="24">{{
                    selectedPersonType == personTypes.Physical ? 'Uzvārds' : 'Nosaukums'
                }}</nz-form-label>
                <nz-form-control clValidationError="surname" [nzSm]="16" [nzXs]="24">
                    <input type="text" nz-input id="surname" formControlName="surname" placeholder="Uzvārds" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired nzFor="code" [nzSm]="8" [nzXs]="24" nzLabelWrap
                    >{{ selectedPersonType == personTypes.Physical ? 'Personas kods' : 'Reģistrācijas nr./PVN reģistrācijas nr.' }}
                </nz-form-label>
                <nz-form-control
                    [nzErrorTip]="codeErrorTip"
                    [nzSuccessTip]="codeSuccessTip"
                    nzHasFeedback
                    nzValidatingTip="Pārbauda..."
                    [nzSm]="16"
                    [nzXs]="24"
                >
                    <input
                        type="text"
                        nz-input
                        id="code"
                        formControlName="code"
                        [placeholder]="selectedPersonType == personTypes.Physical ? 'Personas kods' : 'Reģistrācijas nr./PVN reģistrācijas nr.'"
                    />
                    <ng-template #codeErrorTip let-control>
                        @if (control.hasError('required')) {
                            {{
                                selectedPersonType == personTypes.Physical
                                    ? 'Ievadiet personas kodu'
                                    : 'Ievadiet reģistrācijas nr./PVN reģistrācijas nr.'
                            }}
                        }
                        @if (control.hasError('pattern')) {
                            {{
                                selectedPersonType == personTypes.Physical
                                    ? 'Kļūdains personas kods'
                                    : 'Kļūdains reģistrācijas nr./PVN reģistrācijas nr.'
                            }}
                        }
                        @if (control.hasError('duplicated')) {
                            {{
                                selectedPersonType == personTypes.Physical
                                    ? 'Šāds personas kods jau ir reģistrēts'
                                    : 'Šāds reģistrācijas nr./PVN reģistrācijas nr. jau ir reģistrēts'
                            }}
                        }
                    </ng-template>
                    <ng-template #codeSuccessTip let-control>
                        @if (selectedPersonType == personTypes.Physical && !control.value?.startsWith('32')) {
                            <nz-alert nzType="info" nzMessage="Tiek izmantots 'vecā' tipa personas kods"></nz-alert>
                        }
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired nzFor="phone" [nzSm]="8" [nzXs]="24">Tālrunis</nz-form-label>
                <nz-form-control clValidationError="phone" [nzSm]="16" [nzXs]="24">
                    <input type="text" nz-input id="phone" formControlName="phone" placeholder="Tālrunis" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired nzFor="clientEmail" [nzSm]="8" [nzXs]="24">Epasts</nz-form-label>
                <nz-form-control clValidationError="clientEmail" [nzSm]="16" [nzXs]="24">
                    <input type="email" nz-input id="clientEmail" formControlName="clientEmail" placeholder="Epasts" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzFor="bookkeeperEmail" [nzSm]="8" [nzXs]="24">Grāmatvedības epasts</nz-form-label>
                <nz-form-control clValidationError="bookkeeperEmail" [nzSm]="16" [nzXs]="24">
                    <input type="email" nz-input id="bookkeeperEmail" formControlName="bookkeeperEmail" placeholder="Grāmatvedības epasts" />
                </nz-form-control>
            </nz-form-item>
            <cl-upsert-field
                [fieldId]="'addressId'"
                [fieldLabel]="'Adrese'"
                [(object)]="address"
                [viewModel]="address.fullAddressText"
                [isRequired]="true"
                [isSubmitPerformed]="isSubmitPerformed"
                [upsertComponent]="upsertAddressComponent"
                [fieldErrors]="fieldErrors"
                (validChange)="isAddressValid = $event"
                [isEditMode]="isEditMode"
                [canEdit]="isEditMode && hasMenuAdminOrMenuBookkeeperPermission"
            ></cl-upsert-field>

            <cl-upsert-field
                [fieldId]="'accountId'"
                [fieldLabel]="'Konts'"
                [(object)]="account"
                [viewModel]="account?.accountNr"
                [isRequired]="false"
                [isSubmitPerformed]="isSubmitPerformed"
                [upsertComponent]="upsertAccountComponent"
                [fieldErrors]="fieldErrors"
                (validChange)="isAccountValid = $event"
                [isEditMode]="isEditMode"
                [canEdit]="isEditMode && hasMenuAdminOrMenuBookkeeperPermission"
            ></cl-upsert-field>
            <nz-form-item>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="notes">Piezīmes</nz-form-label>
                <nz-form-control [nzSm]="16" [nzXs]="24">
                    <textarea rows="5" nz-input id="notes" formControlName="notes" placeholder="Piezīmes"></textarea>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzFor="isBlocked" [nzSm]="8" [nzXs]="24" [nzNoColon]="true"></nz-form-label>
                <nz-form-control [nzSm]="16" [nzXs]="24">
                    <label nz-checkbox id="isBlocked" formControlName="isBlocked">Bloķēts</label>
                </nz-form-control>
            </nz-form-item>
            <div *nzModalFooter class="modal-footer">
                <div class="modal-footer-left">
                    @if (isEditMode) {
                        <cl-info-button
                            [id]="originalObject.id"
                            [entityType]="EntityType.Client"
                            (loadingChanged)="loading = $event"
                        ></cl-info-button>
                    }
                </div>
                <div class="modal-footer-right">
                    <button nz-button nzType="default" [disabled]="loading" (click)="cancel()">Atcelt</button>
                    <button nz-button nzType="primary" [disabled]="loading" (click)="validateAndSave()">Saglabāt</button>
                </div>
            </div>
        </form>
    </nz-spin>
}
